import React from 'react';
import {Container, Navbar, Nav, Badge, Dropdown} from 'react-bootstrap';
import {
    NavLink as Link
  } from "react-router-dom";
import { useState } from "react";

import { useEffect } from "react";
import Logo from '../../assets/images/logo.png';
import colorLogo from '../../assets/images/modal-logo.png'
import MyAlgoConnect from '@randlabs/myalgo-connect';
import { ethers } from 'ethers'


const myAlgoWallet = new MyAlgoConnect();
const algosdk = require('algosdk');
function Header() {

let algodClient = new algosdk.Algodv2('', 'https://testnet.algoexplorerapi.io/', '');

const [account, setAccount] = useState('');
const [provider, setProvider] = useState(null);

const connectToEthereum = async () => {
  try {
      if (window.ethereum) {
          const ethProvider = new ethers.providers.Web3Provider(window.ethereum);
          return ethProvider;
      } else {
          throw new Error('No Ethereum wallet found.');
      }
  } catch (error) {
      console.error(error);
      return null;
  }
};

const switchToCorrectNetwork = async () => {
  try {
      const provider = await connectToEthereum();
      if (!provider) return;

      const network = await provider.getNetwork();
      const targetChainId = 8453;

      if (network.chainId !== targetChainId) {
          await window.ethereum.request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId: `0x${targetChainId.toString(16)}` }]
          });
          const signer = provider.getSigner();
      const currentAccount = await signer.getAddress();
      
      setProvider(provider);
      setAccount(currentAccount);
      localStorage.setItem("wallet", currentAccount)
      console.log("success",currentAccount);
      }
  } catch (error) {
      console.error('Error switching network:', error);
  }
};

const connectWalletMetamask = async () => {
  if (window.ethereum) {
    try {
      await window.ethereum.request({ method: 'eth_requestAccounts' });
      const ethProvider = new ethers.providers.Web3Provider(window.ethereum);
      const network = await ethProvider.getNetwork();
      console.log(network.chainId);
      if(network.chainId !== 8453){
          await switchToCorrectNetwork();
      }
      else{
          const signer = ethProvider.getSigner();
      const currentAccount = await signer.getAddress();
      
      setProvider(ethProvider);
      setAccount(currentAccount);
      localStorage.setItem("wallet", currentAccount)
      console.log("success",currentAccount);
      }
      
    } catch (error) {
      console.error('Error connecting to MetaMask:', error);
    }
  } else {
    console.error('MetaMask not detected.');
  }
};

    const connectWallet = async () => {
        try {
          const accounts = await myAlgoWallet.connect();
          const addresses = accounts.map((account) => account.address);
          console.log("addresses : ", addresses);
          localStorage.setItem("walletAddress", addresses[0]);
          const accountInfo = await algodClient.accountInformation(localStorage.getItem("walletAddress")).do();
          console.log("balance", accountInfo);
          localStorage.setItem("algoBalance",(parseInt(accountInfo.amount)/1000000).toFixed(2));
          window.location.reload();
          setShowButton(false);
        } catch (err) {
          console.error(err);
        }
      };
      const wallet = async() => {
        let v = localStorage.getItem("walletAddress");
        if(v){
          setShowButton(false)
        }
        else{
          setShowButton(true)
        }
      }
      useEffect(() =>{wallet()},[localStorage.getItem("walletAddress")])
    
      const [showButton, setShowButton] = useState(true);
      let walletAddress = localStorage.getItem("walletAddress");
    
      const Disconnect = async() => {
        localStorage.setItem("walletAddress", "");
        window.location.reload();
        setShowButton(true)
      }

    return (
        <header className="header">
            <Navbar expand="xl" className='p-0'>
                <Container fluid="lg">
                    <Navbar.Brand href="/"><img src={colorLogo} alt="logo" /></Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.9214 18.6127V20.6127H5.92139V18.6127H16.9214ZM21.9214 11.6127V13.6127H3.92139V11.6127H21.9214ZM19.9214 4.61267V6.61267H8.92139V4.61267H19.9214Z" fill="white"/>
                        </svg>
                    </Navbar.Toggle>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <div className="d-flex mb-4 d-xl-none align-items-center justify-content-between">
                            <Navbar.Brand href="/"><img src={colorLogo} alt="logo" /></Navbar.Brand>

                            <Navbar.Toggle aria-controls="basic-navbar-nav">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" class="bi bi-x-lg" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"/>
                                    <path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"/>
                                </svg>
                            </Navbar.Toggle>
                        </div>
                        <div className="navbar-controls order-xl-2 d-flex align-items-center position-relative">

                            { showButton ? 
                            <button className='btn me-3 btn-grad' onClick={()=>connectWalletMetamask()}>Connect Wallet</button>
                            : <>
                            <button className='btn me-3 btn-grad' onClick={()=>connectWalletMetamask()}>{(localStorage.getItem("walletAddress")).substring(0, 4)}...{(localStorage.getItem("walletAddress")).substring((localStorage.getItem("walletAddress")).length -4, (localStorage.getItem("walletAddress")).length)}</button><br />
                            {/* <button className='btn me-3 btn-grad'>{localStorage.getItem("algoBalance")} ALGO</button> */}
                            <button className='btn me-3 btn-grad' onClick={() =>Disconnect()}>Disconnect</button>
                            </>
                            }

                            <Dropdown className='d-none'>
                                <Dropdown.Toggle variant="language" id="dropdown-basic">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM9.71 19.667C8.72341 17.5743 8.15187 15.3102 8.027 13H4.062C4.25659 14.5389 4.89392 15.9882 5.89657 17.1717C6.89922 18.3552 8.22401 19.2221 9.71 19.667ZM10.03 13C10.181 15.439 10.878 17.73 12 19.752C13.1523 17.6766 13.8254 15.3695 13.97 13H10.03ZM19.938 13H15.973C15.8481 15.3102 15.2766 17.5743 14.29 19.667C15.776 19.2221 17.1008 18.3552 18.1034 17.1717C19.1061 15.9882 19.7434 14.5389 19.938 13ZM4.062 11H8.027C8.15187 8.68979 8.72341 6.42569 9.71 4.333C8.22401 4.77788 6.89922 5.64475 5.89657 6.8283C4.89392 8.01184 4.25659 9.4611 4.062 11ZM10.031 11H13.969C13.8248 8.6306 13.152 6.32353 12 4.248C10.8477 6.32345 10.1746 8.63052 10.03 11H10.031ZM14.29 4.333C15.2766 6.42569 15.8481 8.68979 15.973 11H19.938C19.7434 9.4611 19.1061 8.01184 18.1034 6.8283C17.1008 5.64475 15.776 4.77788 14.29 4.333Z" fill="white"/>
                                    </svg> 
                                    English
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>

                        <Nav className="mx-auto">
                            <Link className='nav-link' to="/launchpad" activeClassName="active">Launchpad<Badge>IN USE</Badge></Link>
                            {/* <Link className='nav-link' to="/stake" activeClassName="active">Stake <Badge>IN USE</Badge></Link> */}
                            {/* <Link className='nav-link' to="/faucet" activeClassName="active">Faucet<Badge>IN USE</Badge></Link> */}
                            <Link className='nav-link' to="#" activeClassName="inactive">Swap</Link>
                            <Link className='nav-link' to="#" activeClassName="inactive">Pool</Link>
                            <Link className='nav-link' to="#" activeClassName="inactive">Farm</Link>
                            <Link className='nav-link' to="#" activeClassName="inactive">Vaults</Link>
                            <Link className='nav-link' to="#" activeClassName="inactive">Bridge</Link>

                            <Link className='nav-link' to="#" activeClassName="inactive">Analytics</Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
                </Navbar>
        </header>
    );
}

export default Header;